var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTimes = function SvgTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.197 14.457c.387.378 1.02.378 1.389.009L7.99 9.06l5.405 5.405a.992.992 0 0 0 1.39-.009.99.99 0 0 0 .008-1.38L9.389 7.663l5.405-5.405c.37-.37.378-1.01-.009-1.38a1 1 0 0 0-1.389-.009L7.991 6.274 2.586.87a1 1 0 0 0-1.389 0c-.378.387-.369 1.028 0 1.389l5.406 5.405-5.406 5.414a.99.99 0 0 0 0 1.38Z",
    fill: "#999"
  })));
};

export default SvgTimes;